import ActionTypes from './../common/ActionTypes';
import Strings from './../common/Strings';
import { uiActions } from './index';
import { history } from '../helpers';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

function setLoading(loading) {
  return {
    type: ActionTypes.INVITING_TEAM,
    loading,
  };
}

function addUpdatingInvitation(email) {
  return {
    type: ActionTypes.ADD_UPDATING_INVITATION,
    email,
  };
}

function removeUpdatingInvitation(email) {
  return {
    type: ActionTypes.REMOVE_UPDATING_INVITATION,
    email,
  };
}

function inviteTeam(companyName, project, emails, note, defaultCurrency) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(setLoading(true));

      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('inviteTeam');
          httpsCallable(
            JSON.stringify({
              idToken,
              companyName,
              project,
              emails,
              note,
              defaultCurrency,
            }),
          )
            .then(() => {
              dispatch(setLoading(false));

              history.goBack();

              // TODO SOMETHING ELSE ?
            })
            .catch(() => {
              dispatch(setLoading(false));
              dispatch(
                uiActions.showError(
                  Strings.ERROR.defaultTitle,
                  Strings.ERROR.errorProjectInvite,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(setLoading(false));
          dispatch(
            uiActions.showError(
              Strings.ERROR.defaultTitle,
              Strings.ERROR.errorProjectInvite,
            ),
          );
        });
    }
  };
}

function inviteTeamReminder(companyName, project, email, defaultCurrency) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(addUpdatingInvitation(email));

      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('inviteTeam');
          const emails = [email];
          httpsCallable(
            JSON.stringify({
              idToken,
              companyName,
              project,
              emails,
              defaultCurrency,
            }),
          )
            .then(() => {
              dispatch(removeUpdatingInvitation(email));
            })
            .catch(() => {
              dispatch(removeUpdatingInvitation(email));
              dispatch(
                uiActions.showError(
                  Strings.ERROR.defaultTitle,
                  Strings.ERROR.errorProjectInvite,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(removeUpdatingInvitation(email));
          dispatch(
            uiActions.showError(
              Strings.ERROR.defaultTitle,
              Strings.ERROR.errorProjectInvite,
            ),
          );
        });
    }
  };
}

function deleteInvitation(projectId, email) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(addUpdatingInvitation(email));

      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('deleteInvitation');
          httpsCallable(JSON.stringify({ idToken, projectId, email }))
            .then(() => {
              dispatch(removeUpdatingInvitation(email));
            })
            .catch(() => {
              dispatch(removeUpdatingInvitation(email));
              dispatch(
                uiActions.showError(
                  Strings.ERROR.errorDeleteInvitationTitle,
                  Strings.ERROR.errorDeleteInvitation,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(removeUpdatingInvitation(email));
          dispatch(
            uiActions.showError(
              Strings.ERROR.errorDeleteInvitationTitle,
              Strings.ERROR.errorDeleteInvitation,
            ),
          );
        });
    }
  };
}

export const inviteActions = {
  inviteTeam,
  inviteTeamReminder,
  deleteInvitation,
};



// WEBPACK FOOTER //
// ./src/actions/invite.js